import $ from 'jquery';
import Subscribe from '@shopify/marketing-assets/javascripts/modules/subscribe';
import {setIsSubscribed} from '../utilities/subscription-cookie';
import Popup from '../modules/popup';

function initializeSubscriptionPopup() {
  const $subscriptionPopup = $('.js-subscription-popup');

  if ($subscriptionPopup.length) {
    const popup = new Popup();
    const $subscriptionForm = $subscriptionPopup.find('.js-subscribe-popup-with-cookie');

    new Subscribe($subscriptionForm, {
      onSuccess: () => {
        setIsSubscribed(true);

        setTimeout(() => {
          popup.closePopup();
        }, 1500);
      },
    });
  }
}

export default initializeSubscriptionPopup;
